import React from "react";
import { Button, Card, Col, ListGroup, Row } from "react-bootstrap";
import { AiFillCheckCircle } from "react-icons/ai";
import "../styles/planDetailStyles.css";

const PlanDetail = ({
  nombre,
  precio,
  tipo,
  diasVigencia,
  tag,
  descripciones,
  onClickBuyCallback,
  showBuyButton = true,
  cardTitle,
}) => {
  return (
    <Card className="h-100" style={{ border: "none", borderRadius: "1rem" }}>
      {cardTitle && (
        <Card.Header className="text-center" as="h5">
          {cardTitle}
        </Card.Header>
      )}
      <Card.Body className="m-3">
        <p
          className="text-start"
          style={{
            color: "#00D6A2",
            letterSpacing: "2px",
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          {nombre.toUpperCase()}
        </p>

        <div className="d-flex align-items-center gap-2">
          <div className="text-end">
            <p style={{ fontSize: "2.5rem", fontWeight: "600" }}>${precio}</p>
          </div>
          <div className="text-start">
            <p className="text-secondary">
              /{tipo === "ANUAL" ? "año" : "mes"}
            </p>
          </div>
        </div>

        <p style={{ fontSize: "0.9rem" }}>{tag}</p>

        <ListGroup as="span" variant="flush">
          {descripciones.filter(Boolean).map((descripcion, index) => (
            <ListGroup.Item as="span" key={index}>
              <AiFillCheckCircle
                color="green"
                style={{ marginRight: "10px" }}
              />
              {descripcion}
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Card.Body>

      {showBuyButton && (
        <Card.Footer
          className="text-center mb-3"
          style={{ border: "none", backgroundColor: "white" }}
        >
          <Button
            className="m-1"
            onClick={onClickBuyCallback}
            style={{
              backgroundColor: "#EDEDED",
              border: "none",
              color: "#00D6A2",
              width: "85%",
            }}
          >
            <b>Comprar</b>
          </Button>
        </Card.Footer>
      )}
    </Card>
  );
};

export default PlanDetail;
